export interface ResponseMessagesProps {
    response: LmsSyncResponse | LmsSyncResponseError;
    name: string;
}

export enum LmsSyncResult {
    Synced = 'synced',
    Skipped = 'skipped',
    Failed = 'failed',
    Unauthorized = 'unauthorized'
}

export enum LmsSyncResultSource {
    Manual = 'manual',
    Cron = 'cron'
}

export enum LmsSyncResultType {
    Calendar = 'calendar',
    Course = 'course',
    Content = 'content',
    Roster = 'roster',
    Attendance = 'attendance',
    AttendanceGrade = 'attendanceGrade',
    Sessions = 'sessions'
}

export type LmsSyncStatus = {
    success: boolean;
    result: LmsSyncResult;
};

export type LmsSyncResponse = {
    status: LmsSyncStatus;
    messages: string[][] | string[];
    errors: string[][] | string[];
};

export type LmsSyncResponseError = {
    error: string;
};

export type LmsSyncRequest = {
    url: string;
    title: string;
    hint?: string;
    inProgress: boolean;
    fetched: boolean;
    enabled: boolean;
    response?: LmsSyncResponse;
};

export type LmsSyncRequests = {
    [key: string]: LmsSyncRequest;
};

export type LmsSyncResultsItem = {
    sid: number;
    class_uuid: string;
    source: LmsSyncResultSource;
    result: LmsSyncResult;
    type: LmsSyncResultType;
    data: LmsSyncResponse;
    created_at: Date;
};

export type LmsSyncResultsResponse = {
    results: LmsSyncResultsItem[];
}
